<template>
    <div class="bg-grey-lighter flex justify-center items-center clearfix p-2 rounded">
        <feather-icon class="cursor-pointer absolute border-none z-10 mr-2" :icon="icon"></feather-icon>
        <vs-select class="w-full" v-selectColor v-model="selected" @input="() => $emit('input', selected)" :props="$props.selectProps" :disabled="disabled" :color="color" :multiple="multiple">
            <slot name="item"></slot>
        </vs-select>
    </div>
</template>

<script>
export default {
    directives: {
        selectColor: {
            inserted: (el, biding, vnode) => {
                el.querySelector(".vs-select--input").style.backgroundColor = "#F1F5F8";
                el.querySelector(".vs-select--input").style.border = "none"
            }
        }
    },

    props:{
        value: String|Number|Array|Object,
        selectProps: Object,
        icon:String,
        multiple: Boolean,
        color: 'String',
        disabled: Boolean
    },

    data () {
        return {
            selected: null
        }
    },

    created () {
        this.selected = this.value;
    }
}
</script>

<style>

</style>
